import { routedClient } from "react-migration/lib/persistence/apollo/routedClient";

/**
 * Calling this will evict the stages query from the Apollo cache and force a
 * refetch of the query.
 */
export const evictStagesCache = () => {
  routedClient.cache.evict({ fieldName: "stages" });
  routedClient.cache.gc();
};
